// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__rCfLs","hasError":"styles_hasError__Bzs13"};